import { createContext } from "react";
import type { SetMultiSelectContextType } from "./SetMultiSelectContext.types";

const MultiSelectContext = createContext<SetMultiSelectContextType | undefined>(undefined);
MultiSelectContext.displayName = "MultiSelectContext";

export default MultiSelectContext;
